function createInfiniteCarousel(containerSelector, direction, options = {}) {
  const {
    speed = 60, // px por segundo (más alto = más rápido)
    pauseWhenHidden = true, // pausa si la pestaña no está visible
  } = options;

  const containers = document.querySelectorAll(containerSelector);
  if (!containers.length) return () => {};

  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  if (reducedMotion) return () => {};

  const destroyFns = [];

  containers.forEach((container) => {
    const slide = container.querySelector('.slide');
    if (!slide) {
      console.error('Slide not found in container:', container);
      return;
    }

    container.style.willChange = 'transform';

    let slideWidth = 0;
    let position = 0;
    let rafId = null;
    let lastTime = 0;

    // Asegura que haya al menos 2 slides
    let clone = container.querySelector(':scope > .slide.clone');
    if (!clone) {
      clone = slide.cloneNode(true);
      clone.classList.add('clone');
      container.appendChild(clone);
    }

    const measure = () => {
      // Ojo: getBoundingClientRect suele ser más consistente que offsetWidth
      slideWidth = slide.getBoundingClientRect().width;

      // Si sigue en 0, probablemente aún no cargó layout (fonts/images)
      if (!slideWidth) return;

      position = direction === 'right' ? -slideWidth : 0;
      container.style.transform = `translate3d(${position}px, 0, 0)`;
    };

    const step = (time) => {
      if (!lastTime) lastTime = time;
      const dt = (time - lastTime) / 1000; // segundos
      lastTime = time;

      const delta = speed * dt; // px a mover en este frame

      if (direction === 'left') {
        position -= delta;
        if (Math.abs(position) >= slideWidth) position = 0;
      } else {
        position += delta;
        if (position >= 0) position = -slideWidth;
      }

      container.style.transform = `translate3d(${position}px, 0, 0)`;
      rafId = requestAnimationFrame(step);
    };

    const start = () => {
      cancelAnimationFrame(rafId);
      lastTime = 0;
      rafId = requestAnimationFrame(step);
    };

    const stop = () => {
      cancelAnimationFrame(rafId);
      rafId = null;
    };

    // Resize (debounce simple)
    let resizeT = null;
    const onResize = () => {
      clearTimeout(resizeT);
      resizeT = setTimeout(() => {
        measure();
      }, 150);
    };

    // Opcional: pausar cuando no está visible
    const onVisibility = () => {
      if (!pauseWhenHidden) return;
      if (document.hidden) stop();
      else start();
    };

    window.addEventListener('resize', onResize);
    document.addEventListener('visibilitychange', onVisibility);

    // Medimos y arrancamos
    measure();
    start();

    destroyFns.push(() => {
      stop();
      window.removeEventListener('resize', onResize);
      document.removeEventListener('visibilitychange', onVisibility);
    });
  });

  return () => destroyFns.forEach((fn) => fn());
}

// Uso (equivalente a lo tuyo):
createInfiniteCarousel('.text-infinite-section .contenedor', 'left', { speed: 70 });
createInfiniteCarousel('.page-about-features .contenedor', 'left', { speed: 70 });

var homeSliderEl = document.querySelector('.carma-home-slider');
if (homeSliderEl && window.Swiper) {
  var swiper = new Swiper(homeSliderEl, {
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false, // para que no se muera al arrastrar/click
    },
    pagination: {
      el: '.custom-swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `
          <span class="${className} slider-bullet">
            <span class="slider-bullet__progress"></span>
          </span>
        `;
      },
    },
    navigation: {
      nextEl: '.custom-button-next',
      prevEl: '.custom-button-prev',
    },
    on: {
      // Swiper 8+ / 9+ suele soportar esto:
      autoplayTimeLeft: function (s, time, progress) {
        // progress: 0 → 1 (1 = ya casi cambia)
        const bullets = s.pagination?.bullets;
        if (!bullets || !bullets.length) return;

        // Resetea todas
        bullets.forEach((b) => b.style.setProperty('--p', 0));

        // Activa la actual (llenar de 0 a 1)
        const activeIndex = s.realIndex;
        const bullet = bullets[activeIndex];
        if (bullet) bullet.style.setProperty('--p', String(1 - progress));
      },

      // Fallback por si autoplayTimeLeft no existiera en tu versión:
      slideChangeTransitionStart: function (s) {
        const bullets = s.pagination?.bullets;
        if (!bullets || !bullets.length) return;
        bullets.forEach((b) => b.style.setProperty('--p', 0));
      },
    },
  });
}
/**
 * Ajusta la altura de los slides y se vuelve a ejecutar en resize (debounced).
 */
(function () {
  function setSlidesHeight() {
    // 1) Selección de elementos
    var slides = document.querySelectorAll('.carma-home-slider .slide');
    var textInfiniteSection = document.querySelector('.text-infinite-section');
    if (!slides.length) return;

    // 2) Medición
    var viewportHeight = window.innerHeight;
    var textSectionHeight = textInfiniteSection ? textInfiniteSection.getBoundingClientRect().height : 0;

    // 3) Cálculo seguro
    var targetHeight = viewportHeight - textSectionHeight;
    if (targetHeight < 0) targetHeight = 0;

    // 4) Aplicación
    for (var i = 0; i < slides.length; i++) {
      slides[i].style.height = targetHeight + 'px';
    }
  }

  // Ejecutar una vez al cargar
  setSlidesHeight();

  // Debounce simple para resize
  var t = null;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(setSlidesHeight, 120);
  });
})();
//piezas escenciales swipper
function initCarmaPiezasSwipers(root) {
  var scope = root || document;
  scope.querySelectorAll('.carma-piezas__swiper').forEach(function (el) {
    if (el.dataset.swiperInit === 'true') return;
    el.dataset.swiperInit = 'true';

    // La barra de progreso vive dentro del mismo tab-pane o sección
    var pane = el.closest('.tab-pane');
    var section = el.closest('.carma-piezas-esenciales') || el.closest('section');
    var progressFill = pane
      ? pane.querySelector('.carma-piezas__progress-fill')
      : section
        ? section.querySelector('.carma-piezas__progress-fill')
        : null;

    var mode = el.getAttribute('data-swiper-mode');
    var config =
      mode === 'cart-recs'
        ? {
            slidesPerView: 1.75,
            spaceBetween: 15,
            breakpoints: {
              576: { slidesPerView: 2.5, spaceBetween: 30 },
              768: { slidesPerView: 3.2, spaceBetween: 30 },
              992: { slidesPerView: 3.5, spaceBetween: 30 },
            },
          }
        : mode === 'diamonds'
          ? {
              slidesPerView: 1,
              spaceBetween: 16,
              breakpoints: {
                768: { slidesPerView: 1.5, spaceBetween: 24 },
                992: { slidesPerView: 2, spaceBetween: 32 },
              },
            }
          : {
              slidesPerView: 'auto',
              spaceBetween: 40,
            };

    new Swiper(el, {
      ...config,
      on: {
        init: function () {
          if (progressFill) progressFill.style.width = '0%';
        },
        // progress: 0..1 (controla el fill)
        progress: function (_s, progress) {
          if (!progressFill) return;
          var p = Math.max(0, Math.min(1, progress));
          progressFill.style.width = (p * 100).toFixed(2) + '%';
        },
      },
    });
  });
}

initCarmaPiezasSwipers();
window.addEventListener('carma:piezas:refresh', function (e) {
  initCarmaPiezasSwipers(e && e.detail && e.detail.root ? e.detail.root : document);
});
//Síguenos
var siguenosSliderEl = document.querySelector('.carma-home-siguenos__slider');
if (siguenosSliderEl && window.Swiper) {
  new Swiper(siguenosSliderEl, {
    slidesPerView: 2,
    spaceBetween: 15,
    loop: true,
    grabCursor: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      992: {
        slidesPerView: 3,
      },
    },
  });
}
/**
 * Carma — Contador de carrito (manual)
 * - Lee /cart.js y actualiza todos los elementos `.cart-count`
 * - Se ejecuta al cargar
 * - Se vuelve a ejecutar cuando dispares `window.dispatchEvent(new Event('cart:updated'))`
 */
(function () {
  function setCountOnDOM(count) {
    var nodes = document.querySelectorAll('.cart-count');
    if (!nodes.length) return;

    nodes.forEach(function (el) {
      el.textContent = String(count);

      // Si estás usando x-cloak o quieres ocultar cuando sea 0:
      if (count > 0) {
        el.style.display = ''; // respeta tu CSS
      } else {
        el.style.display = 'none';
      }
    });
  }

  function fetchCartCount() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        setCountOnDOM(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
      })
      .catch(function () {
        // Si falla, no rompemos nada
      });
  }

  // 1) Al cargar
  document.addEventListener('DOMContentLoaded', fetchCartCount);

  // 2) Cada vez que tú quieras forzar refresh:
  // window.dispatchEvent(new Event('cart:updated'))
  window.addEventListener('cart:updated', fetchCartCount);

  // 3) Bonus: si hay un submit normal al carrito (/cart/add), refresca al volver (bfcache)
  window.addEventListener('pageshow', function () {
    fetchCartCount();
  });

  // (Opcional) Si tu “add to cart” es AJAX y tú controlas el fetch:
  // cuando termine tu fetch de añadir, dispara esto:
  // window.dispatchEvent(new Event('cart:updated'));
})();

/**
 * Carma — Mini cart
 * Separado en:
 * - openMiniCart(): solo abre/cierra (UI)
 * - renderMiniCart(): solo carga/inserta contenido
 */
function openMiniCart() {
  var el = document.getElementById('miniCart');
  if (!el) return;

  // Si ya está abierto, no hacemos nada
  if (el.classList.contains('show')) return;

  // Reusa la instancia si ya existe
  var offcanvasInstance = bootstrap.Offcanvas.getInstance(el) || new bootstrap.Offcanvas(el);
  offcanvasInstance.show();
}

function renderMiniCart(force) {
  var popup = document.querySelector('.mini-cart-popup');
  if (!popup) return;

  if (!force && popup.dataset.sectionLoaded === 'true') return;

  var sectionName = 'carma-main-mini-carrito';

  function normalizeRoot(path) {
    var p = path || '/';
    if (p.charAt(0) !== '/') p = '/' + p;
    if (p.charAt(p.length - 1) !== '/') p += '/';
    return p;
  }

  // 1) Detecta el root localizado real (/es/, /fr/, etc.)
  function resolveLocalizedRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return normalizeRoot(window.Shopify.routes.root);
    }

    if (window.routes && window.routes.root_url) {
      return normalizeRoot(window.routes.root_url);
    }

    // Fallback: detecta prefijo locale en pathname actual.
    var match = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
    if (match) return '/' + match[1] + '/';

    return '/';
  }

  var rootPath = resolveLocalizedRoot();

  // Helper para construir URL dentro del mismo contexto de idioma/preview
  function buildUrl(paramsObj) {
    // Usa root localizado para mantener idioma y contexto (preview/theme editor).
    var baseUrl = new URL(rootPath, window.location.origin);
    var currentUrl = new URL(window.location.href);

    // Mantén query params actuales (preview/theme editor), excepto los de secciones
    currentUrl.searchParams.forEach(function (value, key) {
      if (key === 'sections' || key === 'section_id') return;
      baseUrl.searchParams.set(key, value);
    });

    Object.keys(paramsObj).forEach(function (k) {
      baseUrl.searchParams.set(k, paramsObj[k]);
    });

    return baseUrl.toString();
  }

  // 3) Endpoint JSON (sections=) - recomendado
  var url = buildUrl({ sections: sectionName });

  fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (r) {
      if (!r.ok) throw new Error('Section fetch failed');
      return r.json();
    })
    .then(function (json) {
      var html = json && json[sectionName] ? json[sectionName] : '';
      if (html) {
        popup.innerHTML = html;
        popup.dataset.sectionLoaded = 'true';
        // Notifica que el mini carrito ya fue renderizado (para listeners externos)
        window.dispatchEvent(new Event('miniCart:rendered'));
      }
    })
    .catch(function () {
      // 4) Fallback HTML (section_id=)
      var fallbackUrl = buildUrl({ section_id: sectionName });

      fetch(fallbackUrl, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('Fallback fetch failed');
          return r.text();
        })
        .then(function (html) {
          if (html) {
            popup.innerHTML = html;
            popup.dataset.sectionLoaded = 'true';
            // Notifica que el mini carrito ya fue renderizado (para listeners externos)
            window.dispatchEvent(new Event('miniCart:rendered'));
          }
        })
        .catch(function () {
          // no-op
        });
    });
}

// Mantiene compatibilidad por si aún lo llamas desde otro lado
function showMiniCart() {
  openMiniCart();
  renderMiniCart();
}

// Precarga el contenido del mini carrito al cargar la página
document.addEventListener('DOMContentLoaded', function () {
  renderMiniCart(true);
});

/**
 * Carma — Add to cart (AJAX) para cards
 * - Intercepta submit de formularios que contengan `.product-card-add-to-cart`
 * - Añade/remueve clase `.loading` al botón mientras procesa
 * - Actualiza contador disparando `cart:updated`
 * - Llama a `showMiniCart()` al éxito
 */
(function () {
  function setButtonLoading(btn, isLoading) {
    if (!btn) return;

    // Clase de estado
    btn.classList.toggle('loading', !!isLoading);

    // Evita doble click
    btn.disabled = !!isLoading;

    // Spinner (si existe)
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  async function handleSubmit(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Solo cards
    var btn = form.querySelector('.product-card-add-to-cart');
    if (!btn) return;

    e.preventDefault();

    try {
      setButtonLoading(btn, true);

      var formData = new FormData(form);

      // Asegura cantidad (por si no viniera)
      if (!formData.get('quantity')) formData.set('quantity', '1');

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (!res.ok) {
        // Intenta leer JSON de error para depurar, pero no revienta
        try {
          await res.json();
        } catch (err) {}
        throw new Error('No se pudo añadir al carrito');
      }

      // Actualiza contenido del mini carrito y luego lo abre
      try {
        renderMiniCart(true); // fuerza refresh para que refleje el item recién añadido
        openMiniCart();
      } catch (err) {}
    } catch (err) {
      console.error('[Carma] Add to cart error:', err);
    } finally {
      setButtonLoading(btn, false);
    }
  }

  // Delegación: funciona aunque los cards se re-rendericen
  document.addEventListener('submit', function (e) {
    // Solo forms que tengan nuestro botón
    var target = e.target;
    if (!(target instanceof HTMLFormElement)) return;
    if (!target.querySelector('.product-card-add-to-cart')) return;

    handleSubmit(e);
  });
})();

/**
 * Carma — Add to cart (AJAX) para página de producto
 * - Intercepta submit del form `.product-form`
 * - Reusa el mini carrito y el contador
 */
(function () {
  function setButtonLoading(btn, isLoading) {
    if (!btn) return;
    btn.classList.toggle('loading', !!isLoading);
    btn.disabled = !!isLoading;
  }

  async function handleSubmit(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('product-form')) return;

    var btn = form.querySelector('.add-to-cart-btn');
    if (btn && btn.disabled) return;

    e.preventDefault();

    try {
      setButtonLoading(btn, true);

      var formData = new FormData(form);
      if (!formData.get('quantity')) formData.set('quantity', '1');

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (!res.ok) {
        try {
          await res.json();
        } catch (err) {}
        throw new Error('No se pudo añadir al carrito');
      }

      try {
        renderMiniCart(true);
        openMiniCart();
      } catch (err) {}

      window.dispatchEvent(new Event('cart:updated'));
    } catch (err) {
      console.error('[Carma] Add to cart (PDP) error:', err);
    } finally {
      setButtonLoading(btn, false);
    }
  }

  document.addEventListener('submit', function (e) {
    var target = e.target;
    if (!(target instanceof HTMLFormElement)) return;
    if (!target.classList.contains('product-form')) return;

    handleSubmit(e);
  });
})();
/**
 * Carma — Mini carrito: controlar cantidades (delegación de eventos)
 *
 * Qué hace:
 * - Maneja + / - y edición manual del input dentro de `.mini-cart-popup`.
 * - Maneja eliminar (quantity=0) desde el enlace de borrar.
 * - NO re-renderiza aquí: usa la función existente `renderMiniCart(true)`.
 * - Actualiza el contador disparando `window.dispatchEvent(new Event('cart:updated'))`.
 */
(function () {
  var popup = document.querySelector('.mini-cart-popup');
  if (!popup) return;

  // --- helpers ---
  function clampQty(v) {
    var n = parseInt(v, 10);
    if (Number.isNaN(n) || n < 0) n = 0;
    return n;
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(data),
    }).then(function (r) {
      if (!r.ok) throw new Error('Request failed');
      return r.json();
    });
  }

  function changeLineQty(line, qty) {
    return postJSON('/cart/change.js', { line: Number(line), quantity: Number(qty) });
  }

  function getLineFromHref(href) {
    try {
      var u = new URL(href, window.location.origin);
      var line = u.searchParams.get('line');
      return line ? Number(line) : null;
    } catch (e) {
      return null;
    }
  }

  function refreshUI() {
    // Re-render del mini carrito con la función existente
    if (typeof window.renderMiniCart === 'function') {
      window.renderMiniCart(true);
    }

    // Actualiza contador (tu listener ya lo maneja)
    window.dispatchEvent(new Event('cart:updated'));
  }

  // --- CLICK: + / - / borrar (delegado) ---
  popup.addEventListener('click', function (e) {
    // Ajusta estos selectores si tus botones usan otras clases
    var minus = e.target.closest('.minus');
    var plus = e.target.closest('.more');

    // Borrar (recomendado: añade class `mini-cart-remove` en Liquid)
    var removeLink = e.target.closest('a.mini-cart-remove');
    if (!removeLink) {
      // Fallback: si no hay clase, detecta enlaces con quantity=0
      var maybeLink = e.target.closest('a[href*="quantity=0"]');
      if (maybeLink) removeLink = maybeLink;
    }

    // Si no es ninguno, salimos
    if (!minus && !plus && !removeLink) return;

    // Contenedor de la línea (usted lo define en Liquid)
    var group = e.target.closest('[data-line]');
    if (!group && removeLink) {
      // Si el link no está dentro del contenedor con data-line,
      // intentamos obtenerlo del href.
      var lineFromHref = getLineFromHref(removeLink.getAttribute('href') || '');
      if (lineFromHref != null) {
        group = popup; // placeholder para poder mostrar loading global si quieres
        // Ejecuta cambio directo
        e.preventDefault();
        postJSON('/cart/change.js', { line: Number(lineFromHref), quantity: 0 })
          .then(refreshUI)
          .catch(function (err) {
            console.error(err);
          });
        return;
      }
    }

    if (!group) return;

    var line = group.getAttribute('data-line');
    if (!line) return;

    // Borrar
    if (removeLink) {
      e.preventDefault();
      group.classList.add('loading');

      changeLineQty(line, 0)
        .then(refreshUI)
        .catch(function (err) {
          console.error(err);
        });
      return;
    }

    // + / -
    var input = group.querySelector('input');
    if (!input) return;

    var current = clampQty(input.value);
    var next = current;

    if (minus) next = Math.max(0, current - 1);
    if (plus) next = current + 1;

    if (next === current) return;

    group.classList.add('loading');

    changeLineQty(line, next)
      .then(refreshUI)
      .catch(function (err) {
        console.error(err);
      });
  });

  // --- CHANGE: input manual (delegado) ---
  popup.addEventListener('change', function (e) {
    var input = e.target.closest('input');
    if (!input) return;

    var group = input.closest('[data-line]');
    if (!group) return;

    var line = group.getAttribute('data-line');
    if (!line) return;

    var next = clampQty(input.value);

    group.classList.add('loading');

    changeLineQty(line, next)
      .then(refreshUI)
      .catch(function (err) {
        console.error(err);
      });
  });
})();
/**
 * Complementary products (Shopify Product Recommendations)
 *
 * Estrategia (1 producto base):
 * 1) Cuando el mini carrito termina de renderizar (AJAX), buscamos `.complementary_products`.
 * 2) Leemos el carrito (/cart.js) y tomamos el primer `product_id`.
 * 3) Consultamos recomendaciones JSON con `intent=complementary`.
 * 4) SOLO si hay resultados, pedimos el HTML renderizado vía `/recommendations/products?...section_id=...`.
 */
window.addEventListener('miniCart:rendered', async () => {
  const container = document.querySelector('.complementary_products');
  const limit = 2;
  if (!container) return;

  // ✅ Locale actual (fallbacks seguros)
  const locale = (window.Shopify && window.Shopify.locale) || document.documentElement.getAttribute('lang') || '';

  try {
    const cart = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then((r) => r.json());

    const baseProductId = cart?.items?.[0]?.product_id;
    if (!baseProductId) {
      container.innerHTML = '';
      return;
    }

    const htmlUrl =
      `/recommendations/products?section_id=carma-related-products&product_id=${encodeURIComponent(
        baseProductId,
      )}&limit=${limit}&intent=related` + (locale ? `&locale=${encodeURIComponent(locale)}` : '');

    const html = await fetch(htmlUrl, { credentials: 'same-origin' }).then((r) => r.text());
    container.innerHTML = html || '';
  } catch (err) {
    console.error('[Related products]', err);
  }
});

/**
 * Carma — Related products (PDP) via recommendations endpoint
 * - Usa la sección `carma-related-products` como endpoint de cards
 * - Inserta cards dentro del swiper de `carma-product-related-products`
 */
(function () {
  function buildRecommendationsUrl(productId, limit, locale) {
    var baseUrl = new URL('/recommendations/products', window.location.origin);
    baseUrl.searchParams.set('section_id', 'carma-related-products');
    baseUrl.searchParams.set('product_id', String(productId));
    baseUrl.searchParams.set('limit', String(limit));

    // Mantén query params de preview/theme editor
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.forEach(function (value, key) {
      if (key === 'section_id' || key === 'sections') return;
      if (key === 'product_id' || key === 'limit') return;
      if (key === 'locale') return;
      baseUrl.searchParams.set(key, value);
    });

    if (locale && !baseUrl.searchParams.get('locale')) {
      baseUrl.searchParams.set('locale', locale);
    }

    return baseUrl.toString();
  }

  function renderCardsIntoSwiper(container, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var cards = doc.querySelectorAll('.carma-product-card');
    if (!cards.length) return false;

    var slides = container.querySelector('[data-related-slides]');
    if (!slides) return false;

    slides.innerHTML = '';
    cards.forEach(function (card) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(document.importNode(card, true));
      slides.appendChild(slide);
    });

    return true;
  }

  function initRelatedProducts() {
    document.querySelectorAll('[data-carma-related-products]').forEach(function (container) {
      if (container.dataset.loaded === 'true') return;
      var productId = container.getAttribute('data-product-id');
      if (!productId) return;

      var limit = parseInt(container.getAttribute('data-limit'), 10);
      if (Number.isNaN(limit) || limit < 1) limit = 12;

      var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.getAttribute('lang') || '';
      var url = buildRecommendationsUrl(productId, limit, locale);

      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('Recommendations fetch failed');
          return r.text();
        })
        .then(function (html) {
          var rendered = renderCardsIntoSwiper(container, html);
          if (!rendered) return;
          container.dataset.loaded = 'true';
          window.dispatchEvent(new CustomEvent('carma:piezas:refresh', { detail: { root: container } }));
        })
        .catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', initRelatedProducts);
})();
// Megamenú (vanilla)
// 1) Al pasar el mouse por un item padre, marcarlo como .active y quitar .active del resto
// 2) Si hay algún collapse abierto, cerrarlo "en seco" (sin animación) y abrir el destino también "en seco"
// 3) Si NO hay ninguno abierto, abrir el destino con la animación nativa de Bootstrap
(function () {
  // Contenedor real del megamenú
  var menu = document.querySelector('.megamenu-container');
  if (!menu) return;

  var triggers = document.querySelectorAll('.megamenu-parent');
  if (!triggers.length) return;

  function getAllCollapses() {
    return Array.prototype.slice.call(document.querySelectorAll('.carma-header-megamenu .collapse'));
  }

  function anyOpen(collapses) {
    return collapses.some(function (el) {
      return el.classList.contains('show');
    });
  }

  // Cierra un collapse sin animación (equivalente a jQuery .hide())
  function instantHide(el) {
    el.classList.remove('collapsing');
    el.classList.add('collapse');
    el.classList.remove('show');
    el.style.height = '';
  }

  // Abre un collapse sin animación (equivalente a jQuery .show())
  function instantShow(el) {
    el.classList.remove('collapsing');
    el.classList.add('collapse');
    el.classList.add('show');
    el.style.height = '';
  }

  function removeActiveFromAll() {
    triggers.forEach(function (t) {
      t.classList.remove('active');
    });
  }

  // Cerrar el megamenú cuando el puntero ya NO esté sobre `.megamenu-container`.
  // Usamos `:hover` para hacerlo robusto (el puntero puede “saltar” según la velocidad).
  // Estrategia:
  // - Cuando ocurre `mouseleave`, programamos un cierre.
  // - Esperamos un pequeño delay y verificamos `menu.matches(':hover')`.
  // - Si NO está en hover, cerramos el collapse abierto con animación Bootstrap.
  // - Si el usuario vuelve a entrar rápido (hover vuelve a true), cancelamos el cierre.

  var closeTimer = null;

  function bsCollapse(el) {
    return window.bootstrap && window.bootstrap.Collapse
      ? window.bootstrap.Collapse.getOrCreateInstance(el, { toggle: false })
      : null;
  }

  function hideCollapse(el, animated) {
    if (!el) return;
    var inst = animated ? bsCollapse(el) : null;
    if (inst) inst.hide();
    else instantHide(el);
  }

  function showCollapse(el, animated) {
    if (!el) return;
    var inst = animated ? bsCollapse(el) : null;
    if (inst) inst.show();
    else instantShow(el);
  }

  function closeOpenCollapse(animated) {
    var openEl = menu.querySelector('.collapse.show');

    // Siempre quitamos el estado activo al cerrar
    removeActiveFromAll();

    // Si NO hay nada abierto, solo restauramos el menú y listo
    if (!openEl) {
      if (typeof window.cambiar_menu_principal === 'function') window.cambiar_menu_principal('clear');
      return;
    }

    // Si vamos a cerrar con animación Bootstrap, esperamos a que termine
    // antes de hacer el `clear` (así no se ve el cambio de color antes de tiempo).
    if (animated && window.bootstrap && window.bootstrap.Collapse) {
      openEl.addEventListener(
        'hidden.bs.collapse',
        function () {
          // Solo si ya no queda ningún collapse abierto
          if (!document.querySelector('.carma-header-megamenu .collapse.show')) {
            if (typeof window.cambiar_menu_principal === 'function') window.cambiar_menu_principal('clear');
          }
        },
        { once: true },
      );

      hideCollapse(openEl, true);
      return;
    }

    // Cierre instantáneo (sin animación): el clear puede ser inmediato
    hideCollapse(openEl, animated);
    if (typeof window.cambiar_menu_principal === 'function') window.cambiar_menu_principal('clear');
  }

  function closeAllCollapses(animated, exceptEl) {
    getAllCollapses().forEach(function (c) {
      if (exceptEl && c === exceptEl) return;
      if (!c.classList.contains('show')) return;
      hideCollapse(c, animated);
    });
  }

  function scheduleClose() {
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      closeTimer = null;
      if (menu.matches(':hover')) return;
      closeOpenCollapse(true);
    }, 80);
  }

  function cancelClose() {
    if (!closeTimer) return;
    clearTimeout(closeTimer);
    closeTimer = null;
  }

  menu.addEventListener('mouseenter', cancelClose);
  menu.addEventListener('mouseleave', scheduleClose);

  triggers.forEach(function (trigger) {
    trigger.addEventListener('mouseenter', function () {
      removeActiveFromAll();
      trigger.classList.add('active');

      var position = trigger.getAttribute('data-position');
      if (!position) {
        closeAllCollapses(true);
        if (typeof window.cambiar_menu_principal === 'function') window.cambiar_menu_principal('clear');
        return;
      }

      var target = document.getElementById('collapse-' + position);
      var collapses = getAllCollapses();
      var hadOpen = anyOpen(collapses);

      // Si no existe el destino, cerramos lo abierto con animación Bootstrap.
      if (!target) {
        closeAllCollapses(true);
        if (typeof window.cambiar_menu_principal === 'function') window.cambiar_menu_principal('clear');
        return;
      }

      // Si ya había algo abierto, cambiamos “en seco” (sin animación) para que sea instantáneo.
      if (hadOpen) {
        closeAllCollapses(false);
        showCollapse(target, false);
        cambiar_menu_principal('claro');
        return;
      }

      // Si no había nada abierto, abrimos con animación.
      closeAllCollapses(true, target);
      showCollapse(target, true);
      cambiar_menu_principal('claro');
    });
  });
})();
// Cambia estilos/recursos del menú principal sin depender de jQuery.
// Cambia estilos/recursos del menú principal sin depender de jQuery.
// Soporta:
// - 'claro' / 'oscuro': aplica cambios
// - 'clear': restaura el estado original del DOM (antes de cualquier cambio)
(function () {
  // Guardamos estado original una sola vez por elemento.
  // WeakMap evita fugas de memoria si el DOM se reemplaza.
  var __carmaMenuOriginalState = new WeakMap();

  function snapshot(el) {
    if (!el || __carmaMenuOriginalState.has(el)) return;

    __carmaMenuOriginalState.set(el, {
      className: el.className,
      attributes: (function () {
        var out = {};
        Array.prototype.slice.call(el.attributes || []).forEach(function (a) {
          out[a.name] = a.value;
        });
        return out;
      })(),
    });
  }

  function restore(el) {
    var state = el && __carmaMenuOriginalState.get(el);
    if (!state) return;

    // 1) Restaura clases
    el.className = state.className;

    // 2) Restaura atributos exactamente como estaban
    // - Quitamos los que ya no existen en el snapshot
    Array.prototype.slice.call(el.attributes || []).forEach(function (a) {
      if (!(a.name in state.attributes)) el.removeAttribute(a.name);
    });
    // - Reponemos/actualizamos los del snapshot
    Object.keys(state.attributes).forEach(function (name) {
      el.setAttribute(name, state.attributes[name]);
    });
  }

  function snapshotMany(list) {
    if (!list || !list.length) return;
    Array.prototype.slice.call(list).forEach(snapshot);
  }

  function restoreMany(list) {
    if (!list || !list.length) return;
    Array.prototype.slice.call(list).forEach(restore);
  }

  // Exponemos la función global que ya usas.
  window.cambiar_menu_principal = function (color) {
    var root = document.querySelector('.main-menu-container');
    if (!root) return;

    // Elementos involucrados (mismos que estabas tocando)
    var firstChildDiv = root.querySelector(':scope > div');
    var megamenuParents = root.querySelectorAll('.megamenu-parent');
    var logo = root.querySelector('.logo');
    var lang = root.querySelector('.selector_de_idioma');
    var search = root.querySelector('.buscador');
    var cartLink = root.querySelector('#main-cart');
    var cartImg = cartLink ? cartLink.querySelector('img') : null;
    var mobileBtn = root.querySelector('.mobile-menu-button');

    // 0) Snapshot: guardamos el estado original ANTES de modificar nada.
    snapshot(root);
    snapshot(firstChildDiv);
    snapshotMany(megamenuParents);
    snapshot(logo);
    snapshot(lang);
    snapshot(search);
    snapshot(cartLink);
    snapshot(cartImg);
    snapshot(mobileBtn);

    // CLEAR: revierte TODO lo que se haya tocado, sin importar el modo anterior.
    if (color === 'clear') {
      restore(mobileBtn);
      restore(cartImg);
      restore(cartLink);
      restore(search);
      restore(lang);
      restore(logo);
      restoreMany(megamenuParents);
      restore(firstChildDiv);
      restore(root);
      return;
    }

    // Nota: no usamos 'clear' como un color, solo como reset.
    // Los estilos para claro/oscuro puedes extenderlos sin miedo,
    // porque el reset siempre vuelve al DOM original.

    if (color === 'claro') {
      // Fondo blanco
      if (firstChildDiv) firstChildDiv.classList.add('bg-white');

      // Quita texto blanco en items del megamenú
      megamenuParents.forEach(function (el) {
        el.classList.remove('text-white');
      });

      // Logo (usa data-logo-dark en el contenedor principal)
      if (logo) {
        var logoDark = logo.getAttribute('data-logo-dark');
        if (logoDark) logo.setAttribute('src', logoDark);
      }

      // Selector de idioma
      if (lang) lang.classList.remove('text-white');

      // Buscador
      if (search) search.classList.remove('white');

      // Carrito (cambia el <img> interno según data-cart-*)
      if (cartLink) {
        cartLink.classList.remove('text-white');
        if (cartImg) {
          var cartDark = cartLink.getAttribute('data-cart-dark');
          if (cartDark) cartImg.setAttribute('src', cartDark);
        }
      }

      // Botón menú móvil (usa data-menu-dark en el propio botón)
      if (mobileBtn) {
        var menuDark = mobileBtn.getAttribute('data-menu-dark');
        if (menuDark) mobileBtn.setAttribute('src', menuDark);
      }

      return;
    }

    if (color === 'oscuro') {
      // Ejemplo mínimo: si quieres forzar “oscuro”, hazlo aquí.
      // (Aun así, siempre puedes llamar primero a `cambiar_menu_principal('clear')`
      //  y luego aplicar oscuro para partir del DOM original.)

      // Tu implementación de oscuro puede vivir aquí.
      return;
    }
  };
})();

// Igualar el ancho minimo de .option dentro de cada .product-options
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-options').forEach(function (group) {
    var maxWidth = 0;
    var options = group.querySelectorAll('.option');

    options.forEach(function (option) {
      var width = option.getBoundingClientRect().width;
      if (width > maxWidth) maxWidth = width;
    });

    options.forEach(function (option) {
      option.style.minWidth = maxWidth + 'px';
    });
  });
});
//Blog (About) swiper
var aboutBlogSliderEl = document.querySelector('.carma-about-blog__swiper');
if (aboutBlogSliderEl && window.Swiper) {
  new Swiper(aboutBlogSliderEl, {
    slidesPerView: 1.3,
    spaceBetween: 16,
    grabCursor: true,
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.6,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 3.2,
        spaceBetween: 28,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
}
//Cambiar color de menú cuando se abre en móvil
//hacer esta llamada para abrir el menu: cambiar_menu_principal('claro')
//hacer esta llamada cuando se cierre: cambiar_menu_principal('clear')
document.addEventListener('DOMContentLoaded', function () {
  var mobileMenuCollapse = document.getElementById('collapseMobileMenu');
  if (!mobileMenuCollapse) return;

  mobileMenuCollapse.addEventListener('show.bs.collapse', function () {
    if (typeof window.cambiar_menu_principal === 'function') {
      window.cambiar_menu_principal('claro');
    }
  });

  mobileMenuCollapse.addEventListener('hidden.bs.collapse', function () {
    if (typeof window.cambiar_menu_principal === 'function') {
      window.cambiar_menu_principal('clear');
    }
  });
});
